import { render, staticRenderFns } from "./Webmail.vue?vue&type=template&id=70300ed0&scoped=true&"
import script from "./Webmail.vue?vue&type=script&lang=js&"
export * from "./Webmail.vue?vue&type=script&lang=js&"
import style0 from "./Webmail.vue?vue&type=style&index=0&id=70300ed0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70300ed0",
  null
  
)

export default component.exports